import React from "react";
import HeadTittle from "../../../../components/HeadTittle";
import DivContainerBody from "../../../../components/DivContainerBody";
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../components/StepperTabs/StepTab";
import {ButtonNextStep, ButtonPrevStep} from "../../../../components/buttons/ButtonNavigation";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon} from "../../../../components/buttons/IconButtons";
import CustomPhotoPicker from "../../../../components/PhotoPicker/CustomPhotoPicker";
import {SUGGESTION_MODE_OPTION} from "../../../../components/PhotoPicker/SubComponent/Models/Models";
import FullPageLoader from "../../../../utils/FullPageLoader";
import {ACTION_MODEL} from "../../../../Helpers/ActionModel";
import {FILE_TYPE} from "../../../../Helpers/fileType";
import routes from "../../../../Routes/routes";
import {permissionObj} from "../../../../Helpers/permission";
import Step1Details from "../../Company/Employees/EnrollmentSteps/Step1Details";
import FingerprintStep from "../../Company/Employees/EnrollmentSteps/FingerprintStep";
import FingerPrintSpinner from "../../Company/Employees/Modal/FingerPrintSpinner";
import CopySecretModal from "../../Company/Employees/Modal/CopySecretModal";
import CreateGuardApp from "../Functionality/CreateGuardApp";
import {GUARD_CREATE_STEP_LABELS, GUARD_CREATE_STEPS} from "../Model/Model";
import GuardContractStep from "./Steps/GuardContractStep";
import GuardDocumentsStep from "./Steps/GuardDocumentsStep";
import GuardSummaryStep from "./Steps/GuardSummaryStep";

/**
 * Creation of a guard: details, contract, documents, photo, fingerprint and summary.
 */
const CreateGuard = () => {
    const guard = CreateGuardApp();
    const {
        t,
        navigate, canCreate, disabled, activeStep, setActiveStep, handleStepChange, isStepOptional,
        loadingProgress, capturing, setCapturing, handleCloseModal,
        userData, setUserData, handleFormChangeUserData, handleClearUserData, emptyFields, setEmptyFields,
        isValidEmail, isValidDocumentId, isValidPhoneNumber, isValidDob, setIsValidDob, isValidPin,
        handleValidationStepDetails,
        employeeData, handleFormChangeEmployeeData, isValidEndDate, setIsValidEndDate,
        zoneAccesses, zoneAccessIds, setZoneAccessIds, handleValidationContract,
        documents, addDocument, removeDocument, emptyDocument, handlePendingDocument, handleValidationDocuments,
        photoPickerFile, setPhotoPickerFile, emptySelfie, handleValidationPhoto, isPilgrimsValidation,
        setSelectedReader,
        capturedFingerprint, setCapturedFingerprint, fingerprintSrc, setFingerprintSrc, fingerprintsList,
        fingerprintsTemp, setFingerprintsTemp, mergedFingerprints,
        handleUploadFinger, fingerprintName, setFingerprintName, setUpdated, updatedFinger,
        setModified, handleValidationFinger,
        handleCreateGuard, secretModal, setSecretModal, secretKey, setSecretKey, generatedPassword,
        onSecretModalHide,
    } = guard;

    if (!canCreate) navigate(routes.forbidden);

    const steps = GUARD_CREATE_STEP_LABELS.map((label) => t(label));
    const back = () => setActiveStep((prev) => prev - 1);

    return (
        <>
            {loadingProgress && <FullPageLoader/>}
            {capturing && <FingerPrintSpinner onClose={handleCloseModal} capturing={capturing}/>}
            <HeadTittle link={routes.guards.list} name={'create'}/>

            <DivContainerBody>
                <StepperTabs
                    disabled={disabled}
                    id={null}
                    steps={steps}
                    activeStep={activeStep}
                    isStepOptional={isStepOptional}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                >
                    <StepTab index={GUARD_CREATE_STEPS.DETAILS} activeStep={activeStep} normalHeight={true}>
                        <div className='col-12 d-flex justify-content-end mt-3'>
                            <ButtonIcon
                                className='btn-clean-secondary-600'
                                id='btn_cg_clean'
                                Icon={CleanIcon}
                                title={'clear_instances'}
                                iconProps={'btn-icon-svg-12px icon-color-general-00'}
                                onClick={handleClearUserData}
                            />
                        </div>
                        {/* The details carry their own top margin, it is reduced under the clear button */}
                        <div className={'mt-n3'}>
                            <Step1Details
                                userData={userData}
                                onChange={handleFormChangeUserData}
                                emptyFields={emptyFields}
                                isValidEmail={isValidEmail}
                                isValidDocumentId={isValidDocumentId}
                                isValidPhoneNumber={isValidPhoneNumber}
                                isValidDob={isValidDob}
                                setIsValidDob={setIsValidDob}
                                isValidPin={isValidPin}
                                managePasswordsPermission={permissionObj.WEB_GUARD_CAN_MANAGE_PASSWORDS}
                            />
                        </div>
                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                            <ButtonNextStep id='btn_cg_next_details' text='next' click={handleValidationStepDetails}/>
                        </div>
                    </StepTab>

                    <StepTab index={GUARD_CREATE_STEPS.CONTRACT} activeStep={activeStep} normalHeight={true}>
                        <GuardContractStep
                            employeeData={employeeData}
                            onChange={handleFormChangeEmployeeData}
                            emptyFields={emptyFields}
                            isValidEndDate={isValidEndDate}
                            setIsValidEndDate={setIsValidEndDate}
                            zoneAccesses={zoneAccesses}
                            zoneAccessIds={zoneAccessIds}
                            setZoneAccessIds={setZoneAccessIds}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep id='btn_cg_back_contract' text='back' click={back}/>
                            <ButtonNextStep id='btn_cg_next_contract' text='next' click={handleValidationContract}/>
                        </div>
                    </StepTab>

                    <StepTab index={GUARD_CREATE_STEPS.DOCUMENTS} activeStep={activeStep} normalHeight={true}>
                        <GuardDocumentsStep
                            documents={documents}
                            addDocument={addDocument}
                            removeDocument={removeDocument}
                            emptyFields={emptyDocument}
                            onPendingChange={handlePendingDocument}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep id='btn_cg_back_documents' text='back' click={back}/>
                            <ButtonNextStep id='btn_cg_next_documents' text='next' click={handleValidationDocuments}/>
                        </div>
                    </StepTab>

                    <StepTab index={GUARD_CREATE_STEPS.PHOTO} activeStep={activeStep} normalHeight={true}>
                        <div className={'mt-3'}>
                            {activeStep === GUARD_CREATE_STEPS.PHOTO &&
                                <CustomPhotoPicker
                                    id='fp_cg_create_photo_profile'
                                    photoPicker={photoPickerFile}
                                    setPhotoPicker={setPhotoPickerFile}
                                    actionModel={ACTION_MODEL.CREATE}
                                    accept={{...FILE_TYPE.IMAGE_FACE_VALIDATION}}
                                    showBtnCamera={true}
                                    validateFace={true}
                                    emptyFields={emptySelfie}
                                    classWith={'content-center-w-400px'}
                                    showPreview={true}
                                    disabled={disabled}
                                    required={isPilgrimsValidation}
                                    typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                                />
                            }
                        </div>
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep id='btn_cg_back_photo' text='back' click={back}/>
                            <ButtonNextStep id='btn_cg_next_photo' text='next' click={handleValidationPhoto}/>
                        </div>
                    </StepTab>

                    <StepTab index={GUARD_CREATE_STEPS.FINGERPRINT} activeStep={activeStep} normalHeight={true}>
                        <div className={'mt-3'}>
                            <FingerprintStep
                                t={t}
                                capturing={capturing}
                                setCapturing={setCapturing}
                                capturedFingerprint={capturedFingerprint}
                                setCapturedFingerprint={setCapturedFingerprint}
                                fingerprintSrc={fingerprintSrc}
                                setFingerprintSrc={setFingerprintSrc}
                                updatedFinger={updatedFinger}
                                setFingerprintName={setFingerprintName}
                                setSelectedReader={setSelectedReader}
                                fingerprintsList={fingerprintsList}
                                setUpdated={setUpdated}
                                setModified={setModified}
                                fingerprintName={fingerprintName}
                                handleUploadFinger={handleUploadFinger}
                                userData={userData}
                                fingerprintsTemp={fingerprintsTemp}
                                setFingerprintsTemp={setFingerprintsTemp}
                                mergedFingerprints={mergedFingerprints}
                                emptyFields={emptyFields}
                                setEmptyFields={setEmptyFields}
                            />
                        </div>
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep id='btn_cg_back_finger' text='back' click={back}/>
                            <ButtonNextStep id='btn_cg_next_finger' text='next' click={handleValidationFinger}/>
                        </div>
                    </StepTab>

                    <StepTab index={GUARD_CREATE_STEPS.SUMMARY} activeStep={activeStep} normalHeight={true}>
                        {activeStep === GUARD_CREATE_STEPS.SUMMARY &&
                            <GuardSummaryStep
                                userData={userData}
                                employeeData={employeeData}
                                zoneAccesses={zoneAccesses}
                                zoneAccessIds={zoneAccessIds}
                                documents={documents}
                                photoPicker={photoPickerFile}
                                fingerprints={fingerprintsTemp}
                            />
                        }
                        <div className='col-12 d-flex justify-content-between mt-3'>
                            <ButtonPrevStep id='btn_cg_back_summary' text='back' click={back}/>
                            <ButtonNextStep id='btn_cg_confirm' text='confirm' click={handleCreateGuard}/>
                        </div>
                    </StepTab>
                </StepperTabs>
            </DivContainerBody>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUserData}
                generatedPassword={generatedPassword}
                onHide={onSecretModalHide}
                closeText={'continue'}
            />
        </>
    );
};

export default CreateGuard;
